import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import LocalStorage from 'utils/helpers/localStorage';

const PublicRoute = ({ component: Component, restricted, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props =>
        LocalStorage.isLoggedIn() && restricted ? (
          <Redirect to="/login" />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};

export default PublicRoute;
